/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable remeda/prefer-remeda-typecheck */
import axios from 'axios'
import { useCallback, useState } from 'react'
import { setCookie } from 'react-use-cookie'
import type { Status } from '@velasca/types'
import { getVelascaApiUrl } from '@velasca/utils/get-velasca-api-url'
import { $settings } from '@velasca/utils/globals'

const velascaApiUrl = getVelascaApiUrl(process.env.NODE_ENV)

/**
 * TODO: SHOP-4760.
 */
const newsletterAddTracking = (email: string) => {
  setCookie('newsletter', 'accepted', {
    days: 365,
  })
  const { klaviyo, fbq, _tfa, gtag } = window

  typeof fbq !== 'undefined' && fbq('track', 'Lead')
  typeof _tfa !== 'undefined' &&
    _tfa.push({
      notify: 'event',
      name: 'iscrizionenewsletter',
    })
  typeof gtag !== 'undefined' && gtag('event', 'generate_lead')

  typeof klaviyo !== 'undefined' &&
    $settings.klaviyo_enabled &&
    klaviyo.identify({ $email: email })
  typeof klaviyo !== 'undefined' &&
    $settings.klaviyo_enabled &&
    klaviyo.identify({ $email: email })
}

interface NewsletterAddData {
  success: boolean
}

const newsletterAdd = (email: string) => {
  return axios.post<NewsletterAddData>(`${velascaApiUrl}/newsletter/add`, {
    email,
  })
}

interface NewsletterState {
  status: Status
  setStatus: (status: NewsletterState['status']) => void
  subscribe: (email: string) => void
}

export const useNewsletter = (): NewsletterState => {
  const [status, setStatus] = useState<Status>('idle')

  const subscribe = useCallback(
    (email: string) => {
      setStatus('loading')

      newsletterAdd(email)
        .then(() => {
          setStatus('success')
          newsletterAddTracking(email)
        })
        .catch(() => {
          setStatus('error')
        })
    },
    [setStatus],
  )

  return {
    status,
    setStatus,
    subscribe,
  }
}
